import React, { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import PDFViewer from "./components/PDFViewer";
import usePDFOperations from "./hooks/usePDFOperations";
import "./signature.css";

// Configure PDF.js worker
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const PDFSignatureSelector = ({ onSave, pdfUrl, pdfFile }) => {
  const {
    numPages,
    currentPage,
    scale,
    signaturePositions,
    isSelectingPosition,
    containerRef,
    setNumPages,
    setCurrentPage,
    setScale,
    setIsSelectingPosition,
    handlePdfClick,
    resetState,
    handleMouseMove,
    cursorPosition,
    handleRemoveSign,
  } = usePDFOperations();

  const [isSavingDocument, setIsSavingDocument] = useState(false);

  useEffect(() => {
    onSave({
      success: true,
      pdfUrl,
      pdfFile,
      signaturePositions,
      createdAt: new Date().toISOString(),
    });
  }, [signaturePositions]);

  const togglePositionSelection = () => {
    setIsSelectingPosition(!isSelectingPosition);
  };

  const handleSaveDocument = async () => {
    if (!pdfUrl || !signaturePositions.length) {
      alert("Please upload a PDF and select at least one signature position");
      if (typeof onSave === "function") {
        onSave({
          success: false,
          error:
            "Please upload a PDF and select at least one signature position",
        });
        return;
      }
    }

    try {
      setIsSavingDocument(true);
      if (typeof onSave === "function") {
        onSave({
          success: true,
          pdfUrl,
          pdfFile,
          signaturePositions,
          createdAt: new Date().toISOString(),
        });
      }
    } catch (error) {
      console.error("Error saving document:", error);
      alert("Error saving document. Please try again.");
      if (typeof onSave === "function") {
        onSave({
          success: false,
          error: "Error saving document",
        });
      }
    } finally {
      setIsSavingDocument(false);
      setIsSelectingPosition(false);
    }
  };

  return (
    <div className="ps-wrapper">
      {(pdfUrl || pdfFile) && (
        <div className="ps-selector-actions">
          <button
            className={`ps-button ${isSelectingPosition ? "red" : "blue"}`}
            onClick={togglePositionSelection}
            disabled={isSavingDocument}
          >
            {isSelectingPosition ? "Cancel Selection" : "Select Position"}
          </button>

          <button
            className="ps-button green"
            onClick={handleSaveDocument}
            disabled={!signaturePositions.length || isSavingDocument}
          >
            Save Document
          </button>

          <button
            className="ps-button red"
            onClick={resetState}
            disabled={!signaturePositions.length || isSavingDocument}
          >
            Clear All
          </button>
        </div>
      )}

      <PDFViewer
        pdfUrl={pdfUrl}
        currentPage={currentPage}
        numPages={numPages}
        scale={scale}
        signaturePositions={signaturePositions}
        isSelectingPosition={isSelectingPosition}
        onPageChange={setCurrentPage}
        onScaleChange={setScale}
        onPdfClick={handlePdfClick}
        containerRef={containerRef}
        setNumPages={setNumPages}
        cursorPosition={cursorPosition}
        handleMouseMove={handleMouseMove}
        handleRemoveSign={handleRemoveSign}
      />
    </div>
  );
};

export default PDFSignatureSelector;
